import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationStartContinuousOptimizationCampaignSegmentArgs,
  BackendSegment,
} from 'src/types/backend';

const MUTATION = gql`
  mutation StartSegmentCampaign($campaignId: ID!, $segmentId: ID!) {
    startContinuousOptimizationCampaignSegment(campaignId: $campaignId, segmentId: $segmentId) {
      id
      status
    }
  }
`;

type Variables = BackendMutationStartContinuousOptimizationCampaignSegmentArgs;
type Result = Pick<BackendSegment, 'id' | 'status'>;

export const startSegmentCampaign = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
